import React, { useEffect } from "react";
import styled from "styled-components";
import Modal from "./Modal";
import { BtnGeneral } from "../../styles/Buttons";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Input = styled.input`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
`;

const TextArea = styled.textarea`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  resize: none;
`;

const Select = styled.select`
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
`;

export default function UploadDocumentModal({ isOpen, onClose, hook }) {
  const {
    titulo,
    setTitulo,
    tipo,
    subtipo,
    palabrasClave,
    setPalabrasClave,
    archivo,
    setArchivo,
    tipos,
    subtipos,
    handleTipoChange,
    uploadDocumento,
    loading,
    loadTipos,
    setSubtipo,
  } = hook;

  useEffect(() => {
    if (isOpen) loadTipos();
  }, [isOpen]);

  const handleUploadClick = async () => {
    const success = await uploadDocumento();
    if (success) onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={'Subir Documento PDF'} width="500px">
      <Container>
        <Input
          type="text"
          placeholder="Título"
          value={titulo}
          onChange={(e) => setTitulo(e.target.value)}
        />

        <Select value={tipo} onChange={(e) => handleTipoChange(e.target.value)}>
          <option value="">Seleccione tipo</option>
          {tipos.map((t) => (
            <option key={t.hijo} value={t.hijo}>
              {t.descripcion}
            </option>
          ))}
        </Select>

        <Select
          value={subtipo}
          onChange={(e) => setSubtipo(e.target.value)}
          disabled={!subtipos.length}
        >
          <option value="">Seleccione subtipo</option>
          {subtipos.map((s) => (
            <option key={s.hijo} value={s.hijo}>
              {s.descripcion}
            </option>
          ))}
        </Select>

        <TextArea
          rows="3"
          placeholder="Palabras clave (separadas por comas)"
          value={palabrasClave}
          onChange={(e) => setPalabrasClave(e.target.value)}
        />

        <Input
          type="file"
          accept="application/pdf"
          onChange={(e) => setArchivo(e.target.files[0])}
        />

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
          <BtnGeneral bg="gray" onClick={onClose}>
            Cancelar
          </BtnGeneral>
          <BtnGeneral onClick={handleUploadClick} disabled={loading}>
            {loading ? "Subiendo..." : "Subir"}
          </BtnGeneral>
        </div>
      </Container>
    </Modal>
  );
}
